<template>
	<BaseButton v-on="$listeners">
		<font-awesome-icon :icon="['fa', 'plus']" class="w-5 h-5 pr-1" size="lg" />
		<slot>{{ $t('add') }}</slot>
	</BaseButton>
</template>

<script>
import BaseButton from '@/components/forms/buttons/BaseButton';
export default {
	name: 'AddButton',
	components: { BaseButton },
};
</script>
